module.exports = __webpack_public_path__ + "media/type3(rare).c2acf4a8.mp4";